import { Table, Text } from '@common/ui'
import { com } from '@eidu/web'
import VisualizerTableCell from './VisualizerTableCell'
import type { ColumnHeader, RowHeader } from './utils'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityId = com.eidu.entity.EntityId
import EntityWithLabelAndRelated from '../../../domain/entity/EntityWithLabelAndRelated'

type VisualizerTableRowProps = {
  row: RowHeader
  visibleColumnHeaders: readonly ColumnHeader[]
  totalColumnCount: number
  columnByKey: ReadonlyMap<string, ColumnHeader>
  entityTypes: readonly EntityType[]
  entitiesByTypeId: ReadonlyMap<EntityTypeId, ReadonlyMap<EntityId, EntityWithLabelAndRelated>>
}

const VisualizerTableRow = ({
  row,
  visibleColumnHeaders,
  totalColumnCount,
  columnByKey,
  entityTypes,
  entitiesByTypeId,
}: VisualizerTableRowProps) => {
  if (row.type === 'kind') {
    return (
      <Table.Tr key={row.id}>
        <Table.Td
          colSpan={1 + totalColumnCount}
          style={{
            backgroundColor: 'var(--trellis-color-surface-variant)',
            borderBottom: '1px solid var(--trellis-color-outline)',
            paddingBlock: 4,
          }}
        >
          <Text size="xs" fw={600} tt="uppercase" lts={0.5}>
            {row.label}
          </Text>
        </Table.Td>
      </Table.Tr>
    )
  }

  return (
    <Table.Tr key={row.id}>
      <Table.Td
        style={{
          paddingLeft: row.type === 'entity' ? 'var(--trellis-spacing-lg)' : 'var(--trellis-spacing-xs)',
          whiteSpace: 'nowrap',
          borderRight: '1px solid var(--trellis-color-outline)',
          backgroundColor: 'var(--trellis-color-surface-variant)',
        }}
      >
        {row.label}
      </Table.Td>
      {visibleColumnHeaders.map((column) => (
        <VisualizerTableCell
          key={`${row.id}-${column.id}`}
          row={row}
          column={column}
          columnByKey={columnByKey}
          entityTypes={entityTypes}
          entitiesByTypeId={entitiesByTypeId}
        />
      ))}
    </Table.Tr>
  )
}

export default VisualizerTableRow
